import React, { Fragment } from 'react';
import { Row, Column } from '@upgrade/react-components';
import Fluid from '../Fluid';
import { Hero } from '../common/styles';
import WhoWeAreSection from './who-we-are';
import OurOfficesSection from './our-offices';
import { Heading } from '../common/TypographyPublicSite';
import AwardsSection from './awards';

export default ({ whoWeAre, awardsSections }) => (
  <>
    <Hero>
      <Fluid>
        <Row gutter="small" xsHorizontalAlign="center">
          <Column xs={12} sm={5}>
            <Heading as="h1" color="actionableHover">
              About Us
            </Heading>
          </Column>
        </Row>
      </Fluid>
    </Hero>
    <WhoWeAreSection {...{ whoWeAre }} borderless />
    {awardsSections?.map(awardsSection => {
      return <AwardsSection {...{ ...awardsSection }} />;
    })}
    <OurOfficesSection />
  </>
);
